import Link from 'next/link';

const GlossaryBreadcrumb = ({ glossaryRootPath, glossaryRootLabel, termTitle }) => {
  return (
    <nav aria-label="Drobečková navigace" className="text-grey-500 flex flex-wrap items-center gap-2 text-[13px]">
      <Link href="/" className="hover:text-grey-900 transition-colors">
        Leadhub.co
      </Link>
      <span className="text-grey-400">›</span>
      <Link href={glossaryRootPath} className="hover:text-grey-900 transition-colors">
        {glossaryRootLabel}
      </Link>
      <span className="text-grey-400">›</span>
      <span className="text-grey-900">{termTitle}</span>
    </nav>
  );
};

export default GlossaryBreadcrumb;
